import * as React from 'react'
import { ResizeSizeItem, ResizeGroup } from './types'
import { ResizeCategory } from './ResizeCategory'

export interface ResizeCategoryEntry {
  name: string
  items: ResizeSizeItem[]
  isActive: (item: ResizeSizeItem) => boolean
  onSelectItem: (item: ResizeSizeItem) => void
  renderPremiumBadge?: (item: ResizeSizeItem) => React.ReactNode
  renderExpandedContent?: (item: ResizeSizeItem) => React.ReactNode
  maxInitial?: number
}

interface ResizePanelListProps {
  leading?: React.ReactNode
  categories: ResizeCategoryEntry[]
  headerToggle?: boolean
  footerToggle?: 'none' | 'pill'
}

export function ResizePanelList({
  leading,
  categories,
  headerToggle = true,
  footerToggle = 'none',
}: ResizePanelListProps) {
  return (
    <>
      {leading}
      {categories.map((cat, idx) => (
        <ResizeCategory
          key={cat.name}
          name={cat.name}
          items={cat.items}
          maxInitial={cat.maxInitial}
          isActive={cat.isActive}
          onSelectItem={cat.onSelectItem}
          renderPremiumBadge={cat.renderPremiumBadge}
          renderExpandedContent={cat.renderExpandedContent}
          headerToggle={headerToggle}
          footerToggle={footerToggle}
          className={`section ${idx < categories.length - 1 ? 'mb-50' : ''}`}
        />
      ))}
    </>
  )
}

interface BuildCategoriesOptions {
  getUid: (groupName: string, item: ResizeSizeItem) => string
  selectedUid: string | null | undefined
  onSelect: (groupName: string, item: ResizeSizeItem) => void
  renderPremiumBadge?: (item: ResizeSizeItem, groupName: string) => React.ReactNode
  renderExpandedContent?: (item: ResizeSizeItem, groupName: string) => React.ReactNode
  maxInitial?: number
}

export function buildCategoriesFromGroups(
  groups: ResizeGroup[],
  { getUid, selectedUid, onSelect, renderPremiumBadge, renderExpandedContent, maxInitial }: BuildCategoriesOptions,
): ResizeCategoryEntry[] {
  return groups.map((groupObj) => {
    const groupName = Object.keys(groupObj)[0]
    const items = groupObj[groupName] as ResizeSizeItem[]
    return {
      name: groupName,
      items,
      maxInitial,
      isActive: (item) => getUid(groupName, item) === selectedUid,
      onSelectItem: (item) => onSelect(groupName, item),
      renderPremiumBadge: renderPremiumBadge
        ? (item) => renderPremiumBadge(item, groupName)
        : undefined,
      renderExpandedContent: renderExpandedContent
        ? (item) => renderExpandedContent(item, groupName)
        : undefined,
    }
  })
}
